import { PFSzalagKiemelesVariant } from "../../client/swaggerClient"

export const getSzalagImageUrl = (variant: PFSzalagKiemelesVariant | undefined) => {
  switch (variant) {
    case PFSzalagKiemelesVariant.AkciosAr:
      return {
        badge: '/assets/badges/badge_akcios.png',
        ribbon: '/assets/ribbons/boxribbon_akcios.png'
      }
    case PFSzalagKiemelesVariant.Alkukepes:
      return {
        badge: '/assets/badges/badge_alkukepes.png',
        ribbon: '/assets/ribbons/boxribbon_alkukepes.png'
      }
    case PFSzalagKiemelesVariant.IngyenesSzallitas:
      return {
        badge: '/assets/badges/badge_ingyenszallitas.png',
        ribbon: '/assets/ribbons/boxribbon_ingyenszallitas.png'
      }
    case PFSzalagKiemelesVariant.UtolsoDarab:
      return {
        badge: '/assets/badges/badge_utolsodarab.png',
        ribbon: '/assets/ribbons/boxribbon_utolsodarab.png'
      }
    default:
      return {
        badge: '',
        ribbon: ''
      }
  }
}